<template>
  <!-- content -->
  <div class="board_write_wrap">
    <div class="board_write">
      <div class="write_title">
        <label class="">제목입력</label>
        <input type="text" class="title" v-model="title" maxlength="30" autofocus autocomplete="off" />
      </div>
      <div class="write_content">
        <label class="">공지사항 </label>
        <textarea class="contents" v-model="contents" autofocus autocomplete="off" placeholder="상담 받으실 내용을 작성해 주세요."></textarea>
      </div>
      <div class="board_btn">
        <button v-if="this.$route.query.id == null || this.$route.query.id == ''" @click="onView()" class="bnt_register">등록</button>
        <button v-if="this.$route.query.id > 0" @click="onModify()" class="btn_modify">수정</button>
        <router-link :to="{ name: 'adminList' }" class="bnt_cancel" type="button">취소</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  data() {
    return {
      id: 0,
      title: '',
      writer: '관리자',
      date: '',
      count: 0,
      contents: '',
    }
  },
  created() {
    if (this.$route.query.id > 0) {
      axios
        .get('/api/notice/getOne/' + this.$route.query.id)
        .then((res) => {
          this.title = res.data[0].title
          this.writer = res.data[0].writer
          this.contents = res.data[0].contents
          this.count = res.data[0].count
          history.replaceState({}, null, location.pathname)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },

  methods: {
    onPost() {
      axios({
        url: '/api/notice/postList',
        method: 'POST',
        data: {
          title: this.title,
          writer: this.writer,
          contents: this.contents,
          count: this.count,
        },
      })
        .then((res) => {
          // if (res.data.success == true) {
          // }
        })
        .catch((err) => {
          alert(err)
        })
    },
    onView() {
      this.onPost()
      this.$router.push({ name: 'adminList' })
    },
    onModify() {
      axios({
        url: '/api/notice/update',
        method: 'POST',
        data: {
          id: this.$route.query.id,
          title: this.title,
          writer: this.writer,
          contents: this.contents,
          count: this.count,
        },
      })
        .then((res) => {
          // if (res.data.success == true) {
          // }
        })
        .catch((err) => {
          alert(err)
        })
      this.$router.push({ name: 'adminList' })
    },
  },
}
</script>

<style scoped>
@import '@/style/board.css';
@import '@/style/checkbox.css';
</style>
